<template>
  <div class="computing-facilities-box container">
    <AnimeTitle
      :title="$t('computingFacilities.title')"
      svgRefValue="computingFacilitiesAnimeTitle"
      :computingTitle="$t('computingFacilities.computingTitle')"
    />

    <div
      class="computing-facilities-box-video"
      data-animation="fade-scale-up"
      data-once="false"
    >
      <CustomVideo
        posterVideoUrl="https://img.aikesaisi.com/lkzh/www/model-computing.mp4"
        videoUrl="https://img.aikesaisi.com/lkzh/www/model-computing-poster.mp4"
        :txtInfo="txtInfo"
      />
    </div>
    <GridFrom :list="list" class="computing-grid" />
  </div>
</template>
<script>
import CustomVideo from '@/components/CustomVideo/index.vue';
import GridFrom from '@/components/GridFrom/index.vue';
export default {
  components: {
    CustomVideo,
    GridFrom,
  },
  computed: {
    txtInfo() {
      return {
        title: this.$t('computingFacilities.txtInfo.title'),
        subTitle: this.$t('computingFacilities.txtInfo.subTitle'),
        descr: this.$t('computingFacilities.txtInfo.descr'),
      };
    },
    list() {
      return [
        {
          title: this.$t('computingFacilities.list.item1.title'),
          descr: this.$t('computingFacilities.list.item1.descr'),
          imgUrl: require('@/assets/img/pc/computing-icon1.png'),
        },
        {
          title: this.$t('computingFacilities.list.item2.title'),
          descr: this.$t('computingFacilities.list.item2.descr'),
          imgUrl: require('@/assets/img/pc/computing-icon2.png'),
        },
        {
          title: this.$t('computingFacilities.list.item3.title'),
          descr: this.$t('computingFacilities.list.item3.descr'),
          imgUrl: require('@/assets/img/pc/computing-icon3.png'),
        },
        {
          title: this.$t('computingFacilities.list.item4.title'),
          descr: this.$t('computingFacilities.list.item4.descr'),
          imgUrl: require('@/assets/img/pc/computing-icon4.png'),
        },
      ];
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.computing-facilities-box {
  text-align: center;
  padding-top: 120px;
  .computing-facilities-box-video {
    margin: 60px 0 30px 0;
    width: 100%;
    height: 675px;
  }
  // GridFrom 子项中不同序号 img 的尺寸（穿透到子组件）
  :deep(.computing-grid .grid-from-box_item:nth-child(1) img) {
    width: 65px !important;
    height: 76px !important;
  }
  :deep(.computing-grid .grid-from-box_item:nth-child(2) img) {
    width: 76px !important;
    height: 78px !important;
  }
  :deep(.computing-grid .grid-from-box_item:nth-child(3) img) {
    width: 72px !important;
    height: 67px !important;
  }
  :deep(.computing-grid .grid-from-box_item:nth-child(4) img) {
    width: 72px !important;
    height: 72px !important;
  }
}
</style>
